import React from 'react';

const ModeSelector = ({ mode, onModeChange, t }) => {

  return (
    <div className="mb-4">
      {/* Simple Mode Buttons */}
      <div className="row g-3 mb-4 mode-selector">
        <div className="col-6">
          <input
            type="radio"
            className="btn-check"
            name="mode"
            id="basicMode"
            value="basic"
            checked={mode === 'basic'}
            onChange={() => onModeChange('basic')}
            data-testid="basic-mode-radio"
          />
          <label
            className="btn w-100 d-flex align-items-center justify-content-center p-3"
            htmlFor="basicMode"
            data-testid="basic-mode-label"
          >
            <div className="fw-bold">{t('basicMode')}</div>
          </label>
        </div>
        <div className="col-6">
          <input
            type="radio"
            className="btn-check"
            name="mode"
            id="advancedMode"
            value="advanced"
            checked={mode === 'advanced'}
            onChange={() => onModeChange('advanced')}
            data-testid="advanced-mode-radio"
          />
          <label
            className="btn w-100 d-flex align-items-center justify-content-center p-3"
            htmlFor="advancedMode"
            data-testid="advanced-mode-label"
          >
            <div className="fw-bold">{t('advancedMode')}</div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default ModeSelector;
